(function(){
 function init(root){
  root.querySelectorAll('[data-pg-product]').forEach(function(product){
   if(product.dataset.pgReady)return;product.dataset.pgReady='true';
   var image=product.querySelector('.pg-main-photo'),select=product.querySelector('[data-pg-variant]'),price=product.querySelector('[data-pg-price]'),button=product.querySelector('[data-pg-add]'),quantity=product.querySelector('[data-pg-quantity]'),form=product.querySelector('form');
   function setPhoto(url,alt){if(!image||!url)return;image.removeAttribute('srcset');image.src=url;if(alt)image.alt=alt;product.querySelectorAll('[data-pg-image]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.pgImage===url))})}
   product.querySelectorAll('[data-pg-image]').forEach(function(b){b.addEventListener('click',function(){setPhoto(b.dataset.pgImage,b.dataset.pgAlt)})});
   function update(){if(!select||!button)return;var option=select.options[select.selectedIndex],ready=option.dataset.available==='true'&&Number(option.dataset.price)>0;
    button.disabled=!ready;button.textContent=Number(option.dataset.price)<=0?'Coming soon':ready?'Add to bag':'Sold out';price.textContent=Number(option.dataset.price)>0?option.dataset.money:'Not yet available online';
    if(quantity){quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');var count=Math.max(Number(quantity.min),Number(quantity.value)||1);if(option.dataset.max)count=Math.min(count,Number(option.dataset.max));var increment=Number(quantity.step);count=Number(quantity.min)+Math.floor((count-Number(quantity.min))/increment)*increment;quantity.value=count}
    setPhoto(option.dataset.image,option.dataset.alt);var url=new URL(window.location.href);url.searchParams.set('variant',option.value);try{window.history.replaceState({},'',url.toString())}catch(e){}
   }
   if(select){select.addEventListener('change',update);update()}
   if(form)form.addEventListener('submit',function(event){if(button.disabled)event.preventDefault()});
  });
  root.querySelectorAll('[data-pg-header]').forEach(function(header){if(header.dataset.pgReady)return;header.dataset.pgReady='true';var panels=header.querySelectorAll('details');panels.forEach(function(panel){panel.addEventListener('toggle',function(){if(panel.open)panels.forEach(function(other){if(other!==panel)other.open=false})})});header.addEventListener('keydown',function(e){if(e.key==='Escape')panels.forEach(function(panel){if(panel.open){panel.open=false;panel.querySelector('summary').focus()}})})});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();


/* PawsGuard Google Ads outbound-click tracking */
(function(){
  if(window.__pgGoogleAdsOutboundReady)return;
  window.__pgGoogleAdsOutboundReady=true;

  window.dataLayer=window.dataLayer||[];
  window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};

  if(!document.querySelector('script[src*="googletagmanager.com/gtag/js?id=AW-18496331376"]')){
    var s=document.createElement('script');
    s.async=true;
    s.src='https://www.googletagmanager.com/gtag/js?id=AW-18496331376';
    document.head.appendChild(s);
  }
  window.gtag('js',new Date());
  window.gtag('config','AW-18496331376');

  document.addEventListener('click',function(event){
    var link=event.target.closest&&event.target.closest('a[href]');
    if(!link)return;

    var isAmazonClass=link.classList.contains('pg-amazon-button')||link.classList.contains('pgx-amazon');
    var isAmazonHost=false;
    try{
      var u=new URL(link.href,window.location.href);
      isAmazonHost=/(^|\.)amazon\.(co\.uk|com)$/i.test(u.hostname);
    }catch(e){}

    if(!isAmazonClass&&!isAmazonHost)return;

    window.dataLayer.push({
      event:'pg_amazon_outbound_click',
      pg_link_url:link.href,
      pg_link_text:(link.textContent||'').trim(),
      pg_page_path:window.location.pathname
    });

    window.gtag('event','conversion',{
      send_to:'AW-18496331376/SDURCOKyspIdEPC83vNE',
      value:1.0,
      currency:'GBP',
      transport_type:'beacon'
    });
  },true);
})();
